import React, {useContext, useEffect, useRef, useState} from 'react';
import Dialog from '@material-ui/core/Dialog';
import './style.scss'
import {AppContext} from "../../../Utils/AppContext";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import Users from "./Users/Users";
import UserViewEditContainer from "../../../../Redux/containers/UserViewContainer";

export default function UsersDialog(props) {
    const userViewEditRef = useRef();
    const [users, setUsers] = useState([]);
    const [permittedProfiles, setPermittedProfiles] = useState([]);
    const [selectedUser, setSelectedUser] = useState();
    const [userMode, setUserMode] = useState();

    function handleClose() {
        if (props.onClose)
            props.onClose();
    }

    function onUserSelect(userId) {
        const foundUser = !userId ? undefined : props.users.find(user => user.id === userId);

        setSelectedUser(foundUser);
        setUserMode(foundUser ? "existing" : undefined);
    }

    function onAddUserClicked() {
        setSelectedUser(null);
        setUserMode("new");

        userViewEditRef.current.newUser();
    }

    function onCancelAddUser() {
        setUserMode();
    }

    function onDeletedUser() {
        setSelectedUser(null);
        setUserMode();
    }

    function intersect(a, b) {
        const setB = new Set(b);
        return [...new Set(a)].filter(x => setB.has(x));
    }

    const appContext = useContext(AppContext);

    useEffect(() => {
        if (props.profiles) {
            const userLevel = appContext.permissions.getLevel(props.profiles);

            const newPermittedProfiles = props.profiles.filter(profile => userLevel === 100 || profile.level < userLevel);
            const newPermittedProfileNames = newPermittedProfiles.map(profile => profile.name);

            setPermittedProfiles(newPermittedProfiles);

            const newUsers = userLevel === 100 ? props.users : props.users.filter(user => intersect(Object.keys(user.profiles), newPermittedProfileNames).length);

            setUsers(newUsers);
        }
    }, [props.users, props.profiles]);

    return (
        <Dialog
            fullScreen
            className={"users-dialog " + (appContext.direction === "rtl" ? "dialog-rtl" : "dialog-ltr")}
            open={props.open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title">
            <div className="dialog-content">
                <div className="users-container">
                    <Users users={users}
                           profiles={props.profiles}
                           onUserSelect={onUserSelect}
                           onAddUserClicked={onAddUserClicked}/>
                </div>
                <div className="users-user-separator"/>
                <div className="user-view-container">
                    <UserViewEditContainer ref={userViewEditRef}
                                           user={selectedUser}
                                           userMode={userMode}
                                           onCancelAddUser={onCancelAddUser}
                                           onDeletedUser={onDeletedUser}
                                           permittedProfiles={permittedProfiles}/>
                </div>
            </div>
            <div className="dialog-actions">
                <IconButton className="close-button"
                            onClick={handleClose}>
                    <CloseIcon fontSize="small"/>
                </IconButton>
            </div>
        </Dialog>
    );
}